import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

export interface ChatBubbleProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'content'> {
  asChild?: boolean;
  id: string;
  title: string;
  content: React.ReactNode;
  onOk?: React.MouseEventHandler;
}

const ChatBubble = React.forwardRef<HTMLDivElement, ChatBubbleProps>(
  ({ className, asChild = false, id, title, content, onOk, children, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";

    return (
      <Comp id={id} className={cn("text-start", className)} ref={ref} {...props}>
        <div className="bg-white rounded-md p-3 text-black md:w-96 w-72 text-sm shadow-lg border border-gray-200">
          <div className="font-normal">{title}</div>
          <div>{content}</div>
          <span className="md:hidden block font-normal text-end mt-3" ></span>
        </div>
        {children}
      </Comp>
    );
  }
);

ChatBubble.displayName = "ChatBubble";

export { ChatBubble };
